export const TICKER_ITEMS = [
  { label: 'Color Masterbatch', accent: 'gold' },
  { label: 'White Masterbatch', accent: 'blue' },
  { label: 'UV Stabilizer', accent: 'green' },
  { label: 'NIR Absorber', accent: 'navy' },
  { label: 'Antistatic Masterbatch', accent: 'gold' },
  { label: 'Bio & rPET Solutions', accent: 'green' },
  { label: 'ISO 9001 Certified', accent: 'navy' },
  { label: 'FDA 21 CFR Compliant', accent: 'blue' },
  { label: 'REACH · RoHS · HALAL', accent: 'gold' },
  { label: '25+ Countries Served', accent: 'blue' },
];
